/* eslint-disable import/no-anonymous-default-export */
import http from '../../helpers/http'
import qs from 'qs'

// -------------------------------------------------------
// SSE PARSER — khusus untuk endpoint /endstock/report/merge
// -------------------------------------------------------
// Backend mengirim response sebagai Server-Sent Events (SSE), bukan JSON
// biasa: banyak baris "data: {...}\n\n" (progress, lalu satu event final
// bertipe 'complete' atau 'error'), dan koneksi selalu ditutup dengan
// res.end() (HTTP 200) baik saat sukses MAUPUN saat gagal.
//
// Karena axios menunggu koneksi selesai lalu resolve dengan
// response.data = seluruh teks SSE mentah, kita HARUS parse teks itu
// untuk tahu apakah proses merge-nya benar-benar sukses atau gagal.
export function parseMergeSSE(rawText) {
    if (!rawText || typeof rawText !== 'string') {
        return {
            success: false,
            message: 'Response server tidak valid atau kosong',
            trace: null,
            data: null,
            events: []
        }
    }

    const blocks = rawText.split('\n\n')
    const events = []

    for (const block of blocks) {
        const trimmed = block.trim()
        if (!trimmed) continue

        const lines = trimmed.split('\n')
        for (const line of lines) {
            if (line.startsWith('data:')) {
                const jsonStr = line.slice(5).trim()
                try {
                    events.push(JSON.parse(jsonStr))
                } catch (e) {
                    // Bukan JSON valid (seharusnya tidak terjadi), lewati saja
                }
            }
        }
    }

    // Event final adalah event terakhir yang punya field 'success'
    // (dikirim backend sebagai type: 'complete' atau type: 'error')
    const finalEvent = [...events].reverse().find(e => e && e.success !== undefined)

    if (!finalEvent) {
        return {
            success: false,
            message: 'Tidak menerima status akhir dari server (koneksi mungkin terputus di tengah proses)',
            trace: null,
            data: null,
            events
        }
    }

    if (finalEvent.success) {
        return {
            success: true,
            message: finalEvent.message || 'Reports merged successfully',
            data: finalEvent.data || null,
            events
        }
    }

    return {
        success: false,
        message: finalEvent.message || 'Merge report gagal',
        trace: finalEvent.trace || null,
        data: null,
        events
    }
}

export default {
    // Report Inventory
    uploadEndstock: (token, data, typeUpload) => ({
        type: 'UPLOAD_DATA_ENDSTOCK',
        payload: http(token).post(`/endstock/report/upload?type_upload=${typeUpload === undefined ? 'single' : typeUpload}`, data)
    }),
    updateEndstock: (token, type, data) => ({
        type: 'UPDATE_DATA_ENDSTOCK',
        payload: http(token).post(`/endstock/report/update?type=${type}`, data)
    }),
    getDetailEndstock: (token, id) => ({
        type: 'GET_DETAIL_ENDSTOCK',
        payload: http(token).get(`/endstock/report/detail/${id}`)
    }),
    deleteEndstock: (token, data) => ({
        type: 'DELETE_ENDSTOCK',
        payload: http(token).patch(`/endstock/report/delete`, data)
    }),
    getEndstock: (token, limit, search, page, date, type) => ({
        type: 'GET_ENDSTOCK',
        payload: http(token).get(`/endstock/report/get?limit=${limit}&search=${search}&page=${page === undefined ? 1 : page}&date=${date}&type=${type}`)
    }),
    generateEndstock: (token, data) => ({
        type: 'GENERATE_ENDSTOCK',
        payload: http(token).patch(`/endstock/report/generate`, data)
    }),
    // mergeEndstock SEKARANG memparse SSE response dulu sebelum resolve/reject.
    // Kalau event final dari backend bertipe 'error' (misal file tidak
    // ditemukan, python crash, dll), kita lempar error di sini supaya
    // redux-promise-middleware mengirim action MERGE_ENDSTOCK_REJECTED —
    // bukan FULFILLED seperti sebelumnya.
    mergeEndstock: (token, data) => ({
        type: 'MERGE_ENDSTOCK',
        payload: http(token).patch(`/endstock/report/merge`, data).then((response) => {
            const parsed = parseMergeSSE(response.data)

            if (!parsed.success) {
                const error = new Error(parsed.message)
                error.isSSEError = true
                error.trace = parsed.trace
                throw error
            }

            return { ...response, data: parsed.data, sse: parsed }
        })
    }),
    nextPageEndstock: (token, link) => ({
        type: 'NEXT_DATA_ENDSTOCK',
        payload: http(token).get(`${link}`)
    }),
    resetError: () => ({
        type: 'RESET_ENDSTOCK'
    })
}